export default __webpack_public_path__ + "static/money_icon-86cdda2f20bfd63bdd27645d3287fbd3.svg";